export const default_reg_fields = [
  "about_url",
  "auth_domain",
  "authentication_url",
  "qr_token",
  "registration_url",
  "salt"
];
